import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center">
      <div className="w-14 h-14 rounded-2xl bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center mb-5"><Compass className="w-7 h-7 text-cyan-400" /></div>
      <h1 className="font-display text-5xl font-extrabold text-slate-50">404</h1>
      <p className="text-slate-400 mt-3 mb-6">This page doesn't exist. Let's get you back to discovering opportunities.</p>
      <Link to="/discover"><Button className="bg-cyan-500 text-slate-950 font-semibold">Explore Opportunities</Button></Link>
    </div>
  );
}
